var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconShield48Filled = function SvgIconShield48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.71 11.64-8.72-3.16c-.64-.23-1.34-.23-1.98 0l-8.72 3.17a5.313 5.313 0 0 0-3.49 4.98v5.29c0 10.94 9.14 16.17 11.94 17.51.4.19.83.29 1.26.29.43 0 .86-.1 1.25-.29 2.8-1.34 11.95-6.57 11.95-17.51v-5.29c0-2.22-1.4-4.22-3.49-4.98v-.01Z",
    fill: "current"
  })));
};
export default SvgIconShield48Filled;